<template>
  <div>
    <div :class="[{'label': subNode === null}, {'label-node': subNode !== null }, {'label-expand': sortedArray.length > 5}]">SubNodes</div>
    <div v-if="subNode !== null" :class="['Name',{'Name-expand': sortedArray.length > 5}]"> <img :src="imgSrc" :alt="name"/><p>{{name}}</p></div>
    <div v-else class="Add"><p>&oplus;</p> <a href="https://docs.google.com/forms/d/e/1FAIpQLSflN8Rc0a2317rqEOj2fdWsfXf6Pj8r4IJcN5DxyyTBytx8IQ/viewform" target="_blank">Apply Sub-node</a></div>
    <div v-if="subNode !== null" class="SubNodes">
      <div v-for="node in sortedArray" class="node-item">
        <img :src="node.logo" :alt="name"/><a :href="node.link" target="_blank">{{ node.name }}</a>
      </div>
      <div class="Add-node">
        <p>&oplus;</p><a href="https://docs.google.com/forms/d/e/1FAIpQLSflN8Rc0a2317rqEOj2fdWsfXf6Pj8r4IJcN5DxyyTBytx8IQ/viewform" target="_blank">Apply Sub-node</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Name',
    props: {
      name: String,
      logo: String,
      href: {
        type: String,
        default: '#',
      },
      subNode: Array,
    },
    methods: {
      sortByWeight(a, b) {
        return b.weight - a.weight;
      },
    },
    computed: {
      sortedArray() {
        if (this.subNode) {
          return this.subNode.sort(this.sortByWeight);
        }
          return [];
      },
      imgSrc() {
        return `${this.logo}`;
      },
    },
  };
</script>

<style scoped lang="scss">
  .label {
    display: inline;
    margin-right: 29px;
  }
  .label-node {
    float: left;
    margin-top: 15px;
    margin-right: 29px;
  }
  .label-expand {
    margin-top: 34px;
  }
  .Name {
    float: left;
    margin-top: 13px;
    img {
      vertical-align: middle;
      width: 25px;
      height: 25px;
    }
    p {
      vertical-align: middle;
      display: inline;
      margin-left: 10px;
    }
  }
  .Name-expand {
    margin-top: 32px;
  }
  .Add {
    display: inline-block;
    text-align: left;
    p {
      color: #FF8737;
      vertical-align: middle;
      font-size: 25px;
      display: inline;
    }
    a {
      margin-left: 10px;
      color: #FF8737;
      max-width: none !important;
    }
  }
  .Add-node {
    display: inline-block;
    padding-top: 15px;
    padding-bottom: 15px;
    margin-left: 8px;
    p {
      color: #FF8737;
      vertical-align: middle;
      font-size: 20px;
      display: inline;
    }
    a {
      margin-left: 10px;
      color: #FF8737;
      max-width: none !important;
    }
  }
  .node-item {
    width: 180px;
    padding-left: 11px;
    padding-top: 15px;
    padding-bottom: 15px;
    float: left;
  }
  .SubNodes {
    display: inline-block;
    position: relative;
    max-width: 920px;
    left: 56px;
    img {
      vertical-align: middle;
      width: 25px;
      height: 25px;
    }
    a {
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      max-width: 100px;
      vertical-align: middle;
      margin-left:5px;
      overflow: hidden;
    }
  }
</style>
